<template>
  <router-link
    v-if="visible"
    :to="campaignPath"
    :class="['campaign-entry', 'campaign-entry--' + variant]"
  >
    <span class="entry-label">{{
      phase === "upcoming" ? "双十一预热" : "双十一钜惠"
    }}</span>
    <span v-if="variant === 'banner'" class="entry-description"
      >充值最高加赠 123.6%，九档套餐按需选</span
    >
    <span v-if="variant === 'banner'" class="entry-action">查看活动 &gt;</span>
  </router-link>
</template>

<script>
import { DOUBLE_ELEVEN, getCampaignPhase } from "@/utils/doubleEleven";
export default {
  props: { variant: { type: String, default: "banner" } },
  data() {
    return { now: Date.now(), timer: null, campaignPath: DOUBLE_ELEVEN.path };
  },
  computed: {
    phase() {
      return getCampaignPhase(this.now);
    },
    visible() {
      return (
        ["upcoming", "active"].includes(this.phase) &&
        this.$route.path !== this.campaignPath
      );
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.campaign-entry {
  box-sizing: border-box;
  text-decoration: none;
}
.campaign-entry--banner {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 15px 20px;
  margin-bottom: 18px;
  border: 1px solid #f56b4f;
  border-radius: 8px;
  background: linear-gradient(90deg, #e12826, #f44932);
  color: #fff0c3;
  font-size: 13px;
}
.entry-label {
  font-weight: 700;
  white-space: nowrap;
}
.entry-description {
  color: #ffe0bc;
  font-size: 12px;
}
.entry-action {
  margin-left: auto;
  font-size: 12px;
  white-space: nowrap;
}
.campaign-entry--nav {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  color: #f0442d !important;
  font-size: 14px;
  line-height: 70px;
}
.campaign-entry--nav .entry-action {
  font-size: 14px;
}
.campaign-entry:focus-visible {
  outline: 2px solid #ed3f28;
  outline-offset: 3px;
}
.campaign-entry--banner:hover {
  border-color: #ffbc68;
  background: #dc2220;
}
@media (max-width: 760px) {
  .campaign-entry--banner {
    gap: 8px;
    padding: 12px;
    flex-wrap: wrap;
    font-size: 12px;
  }
  .entry-description {
    font-size: 11px;
    flex-basis: 65%;
  }
  .entry-action {
    font-size: 11px;
  }
}
</style>
